/* eslint-disable no-unused-vars */
import { useCategoryTree } from "@/hooks/category/useCategoryTree";
import { InstantSearch, Index } from "react-instantsearch";
import { mergeGuestCart } from "@/utils/MergeGuestCart";
import { useEffect, useRef, useState } from "react";

import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useCart } from "@/context/cart";

import Footer from "./footer";
import Header from "./header";
import Navbar from "./Navbar";
import FixedBox from "./FixedBox";
import algoliasearch from "algoliasearch/lite";
import SearchBody from "@/components/search/SearchBody";
import Categories from "./categories-bar/Categories";
import FloatingWhatsapp from "./FloatingWhatsapp";
import useShowOnScroll from "@/hooks/useShowOnScroll";
import TopHeader from "./TopHeader";
import useSWR from "swr";
import { getCookie, getCookies } from "cookies-next";
import { getHeaderJson } from "@/services/global";
import CMSAlert from "./CMSAlert";
import toast from "react-hot-toast";
import { handleAddToActiveCart } from "@/utils/global";
import { event_failed_payment } from "@/utils/gtm";

var searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_APP_ID,
  process.env.NEXT_PUBLIC_API_KEY
);

const Layout = ({ children, className }) => {
  const { locale, push, query } = useRouter();
  const handshake = getCookie("handshake");
  const checkout_data = getCookies();
  const ourSearchContainer = useRef(null);
  const ourSearchInput = useRef(null);
  const ourSearchButton = useRef(null);
  const { dispatch: dispatchCart } = useCart();
  const { data: session } = useSession();

  const [isSearching, setIsSearching] = useState(false);
  const [showInstantSearch, setShowInstantSearch] = useState(false);
  const [productIdx, setProductIdx] = useState(
    process.env.NEXT_PUBLIC_ALGOLIA_IDX_AR
  );

  const onStateChange = ({ uiState, setUiState }) => setUiState(uiState);
  const [inputValue, setInputValue] = useState("");

  const setQuery = (newQuery, setInputValue, refine) => {
    setInputValue && setInputValue(newQuery);

    refine && refine(newQuery);
  };

  // check if payment failed show error in toast
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!!query?.order_id && query?.success === "false") {
        handleAddToActiveCart(handshake, query?.order_id, push);
        event_failed_payment(checkout_data);
        toast.error(
          locale === "en"
            ? "Payment Failed, Please try again"
            : "فشلت عملية الدفع, برجاء المحاولة مره اخرى"
        );
      }
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, locale, push, handshake]);

  useEffect(() => {
    setProductIdx(
      locale === "ar"
        ? process.env.NEXT_PUBLIC_ALGOLIA_IDX_AR
        : process.env.NEXT_PUBLIC_ALGOLIA_IDX_EN
    );
  }, [locale]);

  // merge guest cart to user cart
  useEffect(() => {
    mergeGuestCart(session, dispatchCart);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  useEffect(() => {
    if (inputValue) {
      setTimeout(() => {
        setShowInstantSearch(true);
      }, 10);
    }
  }, [inputValue]);

  useCategoryTree();

  const { isShowOnScroll } = useShowOnScroll(20);

  // header json
  const { data } = useSWR(
    () => `header-json-${locale}`,
    () => getHeaderJson(handshake),
    {
      revalidateOnFocus: false,
    }
  );

  const headerJson = data?.data?.data || [];
  // if (pathname.endsWith("/baseeta")) {
  //   return <main className={`${className}`}>{children}</main>;
  // } else
  return (
    <main className={`${className}`}>
      <TopHeader />
      <CMSAlert headerJson={headerJson} />

      <div
        className={`sticky top-0 z-modal ${isShowOnScroll ? "shadow-md" : ""}`}
      >
        <Header headerJson={headerJson} />
        <Navbar
          {...{
            setIsSearching,
            inputValue,
            setInputValue,
            setProductIdx,
            ourSearchInput,
            ourSearchButton,
            locale,
            push,
            headerJson,
          }}
        />
      </div>
      <Categories locale={locale} />
      {showInstantSearch ? (
        <InstantSearch
          indexName={productIdx}
          searchClient={searchClient}
          onStateChange={onStateChange}
          stalledSearchDelay={500}
        >
          <section ref={ourSearchContainer}>
            <Index indexName={productIdx}>
              <SearchBody
                {...{
                  inputValue,
                  setInputValue,
                  setQuery,
                  setIsSearching,
                  ourSearchContainer,
                  ourSearchInput,
                  ourSearchButton,
                }}
              />
            </Index>
          </section>
        </InstantSearch>
      ) : null}
      {!isSearching ? children : null}
      <FloatingWhatsapp />
      <Footer />
      <FixedBox locale={locale} />
    </main>
  );
};

export default Layout;
